export default __webpack_public_path__ + "static/media/pencil-white.c10ee84e.svg";